<template>
  <div class="orderList">
    <hearderCommon :text="text"></hearderCommon>
    <van-tabs v-model="active" class="ty-tabs" @click="ValueList"  style="background-color:rgba(242, 242, 242, 1)">
      <van-tab v-for="index in tabList" :key="index.value" :title="index.label">
        <!-- <router-view @list="list" @Active="Active"></router-view> -->
        <exhibition :orderList="orderList"></exhibition>
      </van-tab>
    </van-tabs>

    <!-- <div class="add_rem">
      <van-button type="primary" size="large" plain round color="#74B42B" @click="goCRDtList">新增补货单</van-button>
    </div>-->
    <div v-if="noSearchList">
      <img src="../../assets/无订单.png" alt class="noList" />
      <p class="search-p">暂无订单</p>
    </div>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";
import exhibition from "./exhibition";
export default {
  data() {
    return {
      active: 0,
      tabList: [],
      text: "资料列表",
      noSearchList: false,
      orderList: []
    };
  },
  created() {
    this.$axios.get(`/sys/sysDict/tool_file_type`).then(res => {
      this.tabList = res.data.data;
      this.active = this.tabList[0].value;
      this.getList(this.active);
    });
  },
  methods: {
    // 订单为空显示
    // list(list) {
    //   console.log(list);
    //   this.orderList = list;
    //   if (list.length === 0) {
    //     this.noSearchList = true;
    //   } else {
    //     this.noSearchList = false;
    //   }
    // },
    Active(Active) {
      this.active = Active;
    },
    ValueList(e) {
      this.getList(e);
    },
    getList(value) {
      this.$axios
        .get(`/customer/customer/getFile?fileValue=${value}`)
        .then(res => {
          if (res.data.code == 0) {
            this.orderList = res.data.data
          }
        });
    }
  },
  components: {
    hearderCommon,
    exhibition
  }
};
</script>

<style scoped>
.orderList {
  background: rgba(242, 242, 242, 1);
  box-sizing: border-box;
  padding: 85px 0 50px 0;
}
header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.ty-tabs {
  font-weight: 700;
  position: fixed;
  width: 100%;
  top: 40px;
  z-index: 9999;
}
.i {
  margin: 10px;
}
.noList {
  width: 100%;
  height: 100%;
  margin-top: 100px;
}
.search-p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
}
.orderList >>> .order-header {
  width: 100px !important;
}
.van-tab {
  transition: all 1s;
}
.orderList >>> .van-tabs__line {
  background-color: #74b42b !important;
}
.orderList >>> .van-tab--active {
  background-color: rgba(249, 249, 249, 1);
  border-bottom: 4px solid #74b42b !important;
  font-weight: 700;
}
.orderList >>> .van-tabs__line {
  display: none !important;
}
.add_rem {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgba(237, 237, 237, 1);
  height: 50px;
  line-height: 50px;
}
.van-button--large {
  width: 50%;
  line-height: 70%;
  height: 70%;
  margin-left: 25%;
  background-color: rgba(237, 237, 237, 1);
}
</style>